export default "__VITE_ASSET__zMyiQDR3__"